(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('CommunicationEntityUserDialogController', CommunicationEntityUserDialogController);

    CommunicationEntityUserDialogController.$inject = ['$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function CommunicationEntityUserDialogController($uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;
        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PARTNER', 'ROLE_SUPERADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            if (angular.isDefined(vm.user.id) && vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
